import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9cabb64a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_patient_time_form = _resolveComponent("patient-time-form")
  const _component_patient_time_table = _resolveComponent("patient-time-table")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")

  return (_openBlock(), _createBlock(_component_vue_content_remain, null, {
    default: _withId(() => [
      _createVNode(_component_vue_two_column_content, null, {
        left: _withId(() => [
          _createVNode(_component_patient_time_form)
        ]),
        right: _withId(() => [
          _createVNode(_component_patient_time_table)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})